import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../../utils/api';

export const requestPasswordReset = createAsyncThunk(
  'forgotPassword/requestPasswordReset',
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await apiCall('POST', '/auth/request-password-reset/', { email });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data.message || 'Request failed');
    }
  }
);

export const confirmPasswordReset = createAsyncThunk(
  'forgotPassword/confirmPasswordReset',
  async ({ uid, token, new_password }: { uid: string; token: string; new_password: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall('POST', '/auth/confirm-password-reset/', { uid, token, new_password });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data.message || 'Reset failed');
    }
  }
);
